import { AccountType } from "../../utils/types";

export { AccountType };

/**
 * Mirrors the server's `ACCOUNTS_ONLY` — the only account types that may fund a
 * trade. Kept in one place so the two panels that gate on it cannot drift apart;
 * the server remains the authority and rejects anything else.
 */
export const FUNDING_ACCOUNT_TYPES = [
  AccountType.ACCOUNT,
  AccountType.CASH,
  AccountType.CHECKING,
  AccountType.OTHER,
];

/** Mirrors the server's `SETTLEMENT_ACCOUNT_TYPES` — the accounts a broker may pay its trades from. */
export const SETTLEMENT_ACCOUNT_TYPES = [
  ...FUNDING_ACCOUNT_TYPES,
  AccountType.SAVINGS,
];

/**
 * The account types the Accounts section owns — the same server-side `ACCOUNTS_ONLY` set the
 * accounts list is scoped to. The account detail page describes an account whose value *is* its
 * transactions, so every other type belongs to the section named below instead.
 */
export const ACCOUNT_SECTION_TYPES = FUNDING_ACCOUNT_TYPES;

/**
 * Where an account type is actually managed, for the types the Accounts section does not own. A
 * `/accounts/:id` URL for one of them is only reachable by hand — nothing links to it — so this
 * exists to send that visitor somewhere true rather than render a chart built from the wrong model.
 */
export const ACCOUNT_TYPE_SECTIONS: Partial<
  Record<AccountType, { label: string; path: string }>
> = {
  [AccountType.INVESTMENTS]: { label: "Investments", path: "/investments" },
  [AccountType.SAVINGS]: { label: "Savings", path: "/savings" },
  [AccountType.LIABILITIES]: { label: "Liabilities", path: "/liabilities" },
};

export const accountTypeToStringMap: Record<AccountType, string> = {
  [AccountType.SAVINGS]: "Savings",
  [AccountType.INVESTMENTS]: "Investments",
  [AccountType.CASH]: "Cash",
  [AccountType.CHECKING]: "Checking",
  [AccountType.LIABILITIES]: "Liabilities",
  [AccountType.ACCOUNT]: "Account",
  [AccountType.OTHER]: "other",
};

export const accountTypeMap: Record<string, AccountType> = {
  Savings: AccountType.SAVINGS,
  Investments: AccountType.INVESTMENTS,
  Cash: AccountType.CASH,
  Checking: AccountType.CHECKING,
  Liabilities: AccountType.LIABILITIES,
  Account: AccountType.ACCOUNT,
  Other: AccountType.OTHER,
};
